import type { Flash } from "@scripts/generated/models/flash";

export const idFromFlash = (flash: Flash) => `${flash.type._tag.toLowerCase()}-${flash.msg}`;
